import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import React from 'react';
import {
  IUserInfos,
  IUserInfo,
} from 'store/makhsanUserInfo/makhsanUserInfoSlice';
import Input from '../Input';
import { CompanyMembersFilterBox } from '../../containers/Tasks/CompanyManagement/styles';
import messages from './Messages';
import { Item, UserItems } from './styles';
import { searchSecurityLogs } from '../../api/MakhsanApi';
import {
  IUserSecurityEvent,
  LogType,
  SecurityEventLevel,
} from 'store/entity/IUserSecurityEvent';
import { smartDateString } from '../../utils/date';
import LoadingCircleIndicator from '../LoadingCircleIndicator/LoadingCircleIndicator';
import Button from '../Button/Button';
import notify from '../Notify';
import { responseTitleStyle } from '../FileManager/ItemsViewer/Survey/SurveyResponseViewer/styles';
import Collapsible from '../Collapsible';
import { appDispatch, IUsers, RootState } from 'store/store';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import { IThisUserState } from 'store/thisUser/thisUserSlice';

interface IStateToProps {
  thisUser: IThisUserState;
  userInfos: IUserInfos;
  users: IUsers['map'];
  store: RootState;
}

interface IOwnProps {
  user?: IUserInfo;
}
interface IDispatchToProps {
  requireSeveralUser: (
    usersList: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
}

interface IComponentState {
  type?: string;
  level?: SecurityEventLevel;
  ip?: string;
  logs: IUserSecurityEvent[];
  loading?: boolean;
}
type IComponentProps = IStateToProps & IOwnProps & IDispatchToProps;

class SecurityLogViewPanel extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  state: IComponentState = {
    loading: false,
    logs: [],
    level: this.props.user ? undefined : SecurityEventLevel.warn,
  };
  handleSearch = () => {
    const { type, level, ip } = this.state;
    this.setState({ loading: true });
    searchSecurityLogs(
      this.props.store,
      100,
      type,
      undefined,
      undefined,
      ip,
      level,
      this.props.user ? this.props.user.user_id : undefined,
      undefined
    ).then(
      (result) => {
        this.setState({ loading: false, logs: result.data });
      },
      (e) => {
        this.setState({ loading: false });
        notify(e.data.message);
      }
    );
  };

  componentDidUpdate(prevProps: Readonly<IComponentProps>): void {
    if (prevProps.user !== this.props.user) this.handleSearch();
    const notFoundUserIds: Set<number> = this.state.logs.reduce(
      (result: Set<number>, item: IUserSecurityEvent) => {
        if (item.actorUser && !this.props.users[item.actorUser]) {
          result.add(item.actorUser);
        }
        if (item.targetUser && !this.props.users[item.targetUser]) {
          result.add(item.targetUser);
        }
        return result;
      },
      new Set<number>()
    );
    if (notFoundUserIds.size > 0)
      this.props.requireSeveralUser(Array.from(notFoundUserIds));
  }

  componentDidMount(): void {
    this.handleSearch();
  }

  render() {
    const { loading, logs, level, ip, type } = this.state;
    const { user, users } = this.props;
    return (
      <div>
        <CompanyMembersFilterBox className=" row ">
          <Input
            id="ip"
            type="text"
            onChange={(e) => {
              this.setState({ ip: e.target.value });
            }}
            placeholder={messages.ipaddress}
            value={ip}
            wrapperClassName="search-user-by-name-input col s12 m3"
          />
          <select
            className="browser-default col s12 m1"
            name="level"
            id="level"
            onChange={(e) => {
              this.setState({
                level: e.target.value
                  ? SecurityEventLevel[e.target.value]
                  : null,
              });
            }}
            value={level}
          >
            <option value="null">{messages.level}</option>
            {Object.keys(SecurityEventLevel).map((i) => (
              <option value={SecurityEventLevel[i]} key={SecurityEventLevel[i]}>
                {messages[SecurityEventLevel[i]]}
              </option>
            ))}
          </select>
          <select
            className="browser-default col s12 m3"
            name="type"
            id="type"
            onChange={(e) => {
              this.setState({
                type: e.target.value ? LogType[e.target.value] : null,
              });
            }}
            value={type}
          >
            <option value="null">{messages.type}</option>
            {Object.keys(LogType).map((i) => (
              <option value={LogType[i]} key={LogType[i]}>
                {messages[LogType[i]]}
              </option>
            ))}
          </select>
          <Button onClick={this.handleSearch}>{messages.search}</Button>
        </CompanyMembersFilterBox>
        <div style={{ display: 'flex' }}>
          {loading ? (
            <LoadingCircleIndicator />
          ) : (
            <UserItems helve={false}>
              {logs.map((log: IUserSecurityEvent) => {
                return (
                  <Collapsible
                    headerBackgroundColor="var(--tertiary-gray)"
                    customHeaderStyle={responseTitleStyle}
                    defaultOpen={false}
                    key={log.id.toString()}
                    header={
                      <Item
                        level={log.level}
                        className="row"
                        key={log.id.toString()}
                        isActive={false}
                      >
                        {!user && log.targetUser && (
                          <div className="col s12 m12">
                            {messages.targetUser +
                              ': ' +
                              (users[log.targetUser].name || log.targetUser)}
                          </div>
                        )}
                        <div className="col s12 m12">
                          {messages.type +
                            ': ' +
                            (messages[log.type] || log.type || '-')}
                        </div>
                        <div className="col s12 m6">
                          {messages.actor +
                            ': ' +
                            (users[log.actorUser]?.name ||
                              log.actorUser ||
                              '-')}
                        </div>
                        <div className="col s12 m6">
                          {messages.date +
                            ': ' +
                            smartDateString(new Date(log.date), true)}
                        </div>
                      </Item>
                    }
                  >
                    <Item
                      className="row"
                      key={log.id.toString() + 'in'}
                      isActive={false}
                    >
                      <div className="col s12 m8">
                        {messages.description + ': ' + (log.description || '-')}
                      </div>
                      <div className="col s12 m4">
                        {messages.ip + ': ' + (log.ip || '-')}
                      </div>
                    </Item>
                  </Collapsible>
                );
              })}
            </UserItems>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const userInfos = state.makhsanUserInfo;
  const thisUser = state.thisUser;
  const users = state.users.map;
  return { userInfos: userInfos, thisUser, store: state, users };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => ({
  requireSeveralUser: (usersList: number[]) =>
    appDispatch(requireSeveralUser({ usersList })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecurityLogViewPanel);
